// extracted by mini-css-extract-plugin
export default {"notViewed":"styles_notViewed__7wbs0","viewed":"styles_viewed__UsHQh","blockBtn":"styles_blockBtn__EYoSh"};